import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';

@Injectable({ providedIn: 'root' })
export class MyApplicationsService {
  constructor(private http: HttpClient, private readonly httpservice: HttpService) {}

  getAllApplications(): Observable<any[]> {
    // Adjust the URL if your backend is on a different base path
    return this.http.post<any[]>('/api/application/all', {});
  }

    getLookupData(): Observable<any[]> {
    // Adjust the URL to your actual lookup API endpoint
    return this.http.get<any[]>('/api/lookup', { params: { requestType: 'APPLICATION_TYPES' } });
    // If it's a POST, use: return this.http.post<any[]>('/api/lookup', {});
  }
   applicationConversion(request: any): Observable<any> {
      return this.httpservice.post('/application-flow/applicationConversion', request);
    }
}
